import { getDataWithQueryString } from '../../../../api/componentAPIs';
import { pluralize } from '../../Reports/DriverPerformance/util';
import { constants } from './constants';

const getWarningMessageForDeleteFlow = (terminalToCustomerMappedData) => {
  const totalMappedTerminals = terminalToCustomerMappedData.length;
  let message = '';
  if (totalMappedTerminals) {
    const totalMappedCustomers = terminalToCustomerMappedData.reduce(
      (sum, mapping) => sum + mapping.totalMappedCustomers,
      0
    );
    message = `Holiday is assigned to ${pluralize(totalMappedCustomers, 'customer')} in ${pluralize(
      totalMappedTerminals,
      'terminal'
    )}.`;
  }
  return message;
};

const checkTerminalsAvailability = (terminalApplicable, userAccessibleTerminals) => {
  return terminalApplicable.some(
    (terminal) => !userAccessibleTerminals.some((userTerminal) => userTerminal.value === terminal)
  );
};

const getUnassignedHolidayWarningMessage = (holidayData, userAccessibleTerminals) => {
  let message = '';
  if (
    !holidayData.terminalApplicable ||
    holidayData.countryApplicable?.length ||
    checkTerminalsAvailability(holidayData.terminalApplicable, userAccessibleTerminals)
  ) {
    message = constants.MESSAGE.UNASSIGNED_HOLIDAY_WARNING;
  }
  return message;
};

const isCustomerAssignedTerminal = (assignedCustomerTerminalList, terminals) => {
  return assignedCustomerTerminalList.some(
    (assignedTerminal) => !terminals.includes(assignedTerminal)
  );
};

const isCustomerAssignedCountry = (assignedCustomerCountryList, countryList) => {
  return assignedCustomerCountryList.some(
    (assignedCountry) => !countryList.includes(assignedCountry)
  );
};

const getWarningMessageForEditFlow = (props) => {
  const { holidayDetails, assignedCustomerTerminals } = props;
  const { terminalApplicable, nonAccessibleTerminals, countryApplicable } = holidayDetails;
  const assignedCustomerCountryList = assignedCustomerTerminals.map((t) => t.country);
  const assignedCustomerTerminalList = assignedCustomerTerminals.map((t) => t.terminalCode);
  const accessibleAndNonAccessibleTerminals = [...nonAccessibleTerminals, ...terminalApplicable];
  if (!countryApplicable?.length && terminalApplicable.length === 0) {
    //when none of the country and terminals selected
    return '';
  }
  let isCustomerAssigned =
    countryApplicable?.length && terminalApplicable.length === 0
      ? isCustomerAssignedCountry(assignedCustomerCountryList, countryApplicable)
      : isCustomerAssignedTerminal(
          assignedCustomerTerminalList,
          accessibleAndNonAccessibleTerminals
        );
  //when only terminals selected
  return isCustomerAssigned ? getWarningMessageForDeleteFlow(props.assignedCustomerTerminals) : '';
};

const getHolidayValidationDetails = (holidayId) => {
  return getDataWithQueryString('ValidateHoliday', `holidayId=${holidayId}`);
};

export {
  getWarningMessageForDeleteFlow,
  getWarningMessageForEditFlow,
  getHolidayValidationDetails,
  getUnassignedHolidayWarningMessage,
};
